import { cartOutput } from "rsl-api-106/lib/outputs/cart";
import { customerBookingOutputWithoutCriterias } from "rsl-api-106/lib/outputs/customerBooking";
import {
  DoFastCheckinInput,
  OccupantProductsInput,
  Session,
  UnlockBookingInput,
} from "rsl-api-106/lib/types";

import { DocumentNode, gql } from "@apollo/client";

export const resetAndChooseProposalFromKeysMutation = (): DocumentNode => {
  return gql`
        mutation resetAndChooseProposalFromKeys($session: Session!, $input: ChooseProposalFromKeysInput!){
            resetCart(
                session: $session
            ) {
                cart {
                    reservations {
                        id
                    }
                }
            },
            chooseProposalFromKeys(
                session: $session,
                input: $input
            ) {
                cart {
                    ${cartOutput}
                }
            }
        }
    `;
};

export const getAccommodationProductsForStepsQuery = (): DocumentNode => {
  return gql`
    query getAccommodationProductsForSteps(
      $session: Session!
      $input: AccommodationProductsInput!
    ) {
      getAccommodationProducts(session: $session, input: $input) {
        accommodationProducts {
          categoryCode
          categoryLabel
          products {
            id
          }
        }
      }
    }
  `;
};

export const updateBookingCriteriasMutation = (): DocumentNode => {
  return gql`
         mutation updateBookingCriterias($session: Session!, $input: UpdateBookingCriteriasInput!) {
            updateBookingCriterias(session: $session, input: $input) {
                cart {
                    ${cartOutput}
                }
            }
        }
    `;
};

/* Enchainer les deux mutation unlock + updateCustomerBooking -- FCI */
export type MutationUnlockBookingAndDoFastcheckinArgs = {
  session: Session;
  inputUnlock: UnlockBookingInput;
  inputDoFastcheckin: DoFastCheckinInput;
};

export const unlockBookingAndDoFastcheckinMutation = (): DocumentNode => {
  return gql`
        mutation unlockBookingAndDoFastcheckin($session: Session!, $inputUnlock: UnlockBookingInput!, inputDoFastcheckin: DoFastCheckinInput){
            resetCart(
                session: $session
            ) {
                cart {
                    reservations {
                        id
                    }
                }
            },
            unlockBooking(
                session: $session,
                input: $inputUnlock
            ) {
                bookingUnlocked
            },
            doFastCheckin(
                session: $session,
                input: $inputDoFastcheckin
            ) {
                reservation {
                    id
                }
            }
        }
    `;
};

export type QueryHasProductsForOccupantWithoutTaxesArgs = {
  session: Session;
  input: OccupantProductsInput;
};

export const hasProductsForOccupantWithoutTaxesQuery = () => {
  return gql`
    query hasProductsForOccupantWithoutTaxes(
      $session: Session!
      $input: OccupantProductsInput
    ) {
      getOccupantProducts(session: $session, input: $input) {
        occupantProducts {
          categoryCode
          categoryLabel
          products {
            id
            code
            mandatory
          }
        }
      }
    }
  `;
};

export const doFastCheckinLightMutation = (): DocumentNode => {
  return gql`
    mutation doFastCheckin($session: Session!, $input: DoFastCheckinInput) {
      doFastCheckin(session: $session, input: $input) {
        reservation {
          id
          cartItemID
        }
      }
    }
  `;
};

export const getCustomerBookingsWithoutCriteriasQuery = (): DocumentNode => {
  return gql`
          query getCustomerBookings($session: Session!, $input: CustomerBookingsInput) {
              getCustomerBookings (
                  session: $session,
                  input: $input
              ) {
                  customerBookings {
                      ${customerBookingOutputWithoutCriterias}
                  }
              }
          }
      `;
};

export const getCustomerBookingsIdsQuery = (): DocumentNode => {
  return gql`
    query getCustomerBookings(
      $session: Session!
      $input: CustomerBookingsInput
    ) {
      getCustomerBookings(session: $session, input: $input) {
        customerBookings {
          id
          externalCode
        }
      }
    }
  `;
};
